module.exports = __webpack_public_path__ + "media/images/pc/brands/aqua/_main-visual-text-e3ebe17cfeeecce97f1f6f1455ced783.svg";